import React, { useState, useEffect } from "react";
import { Drawer } from "antd";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { FaSearch } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { setImagesDrawer } from "../../slices/creatorSlice";
import axios from "axios";
import { addImageFromPexels } from "../../CommonFunctions/PropertybarFunctions";

const ImagesDrawer = ({ canvas }) => {
  const visible = useSelector((state) => state.creator.imagesDrawerOpen);
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [imgLoader, setImgLoader] = useState(false);
  const [result, setResult] = useState([]);

  function handleChange(event) {
    const search = event.target.value;
    setSearch(search);
  }
  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault();
    }
    var url = "";
    if (search) {
      url = "https://api.pexels.com/v1/search?query=" + search + "&per_page=25";
    } else {
      url = "https://api.pexels.com/v1/curated?per_page=25";
    }

    setLoader(true);
    const access_token = process.env.REACT_APP_PEXELS_API_KEY;
    const data = await axios.get(url, {
      headers: {
        Authorization: `${access_token}`,
      },
    });
    if (data) {
      setResult(data.data.photos);
      setLoader(false);
    }
  };
  useEffect(() => {
    handleSubmit();
  }, []);
  const insertImage = async (src) => {
    addImageFromPexels(src, canvas, setImgLoader);
  };

  return (
    <Drawer
      title="Images"
      placement={"left"}
      closable={true}
      onClose={() => {
        dispatch(setImagesDrawer(!visible));
      }}
      visible={visible}
      key={"left"}
    >
      <div className="flex justify-between items-center w-full mb-6">
        <input
          type="text"
          onChange={handleChange}
          className="w-full h-auto border-blue-200 border rounded-md mr-2 py-1 text-[18px] focus:border-blue-400 focus:outline-blue-300 font-medium pl-1"
        />
        <button
          onClick={handleSubmit}
          className="w-max max-w-max bg-blue-200 text-black font-bold rounded-full p-3 ml-2"
        >
          <FaSearch />
        </button>
      </div>
      {loader ? (
        <div className="animate-spin flex text-[50px] font-bold text-blue-300 justify-center items-center mt-6">
          <AiOutlineLoading3Quarters />
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-2 relative">
          {imgLoader ? (
            <div className="h-full w-full absolute opacity-70 bg-white flex justify-center items-start">
              <div className="animate-spin flex text-[36px] font-bold text-blue-300 justify-center items-center mt-14 absolute top-0">
                <AiOutlineLoading3Quarters />
              </div>
            </div>
          ) : null}

          {result.map((images) => {
            return (
              <div
                key={images.id}
                className="flex justify-center align-middle"
              >
                <img
                  src={images.src.medium}
                  alt={images.photographer}
                  className="w-full m-1 rounded-md cursor-pointer transition duration-300 ease-in-out hover:shadow-2xl"
                  onClick={(e) => {
                    // e.preventDefault();
                    setImgLoader(true);
                    insertImage(images.src.original);
                  }}
                />
              </div>
            );
          })}
        </div>
      )}
    </Drawer>
  );
};

export default ImagesDrawer;
